var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tab-body"},[_c('div',{staticClass:"errFrame"},[_c('img',{staticClass:"errFrame-img",attrs:{"src":require("assets/gif/404.gif")}}),_c('div',{staticClass:"errFrame-text"},[_vm._v("抱歉，没有找到页面")])])])
}]

export { render, staticRenderFns }